import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import nbrApi from '../../../services/nbrApi';

// const ownershipOptions = [
//     { value: 'option1', label: 'Option 1' },
//     { value: 'option2', label: 'Option 2' },
//     { value: 'option3', label: 'Option 3' },
// ];

const regionOptions = [
    { value: 1, label: 'Oklahoma' },
    { value: 2, label: 'Texas' },
];

const statusOptions = [
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
];

function PropertyForm(props) {
    const [ownership, setOwnership] = useState('');
    const [ownershipOptions, setOwnershipOptions] = useState([])
    const [region, setRegion] = useState('');
    const [propertyName, setPropertyName] = useState('');
    const [propertyDescription, setPropertyDescription] = useState('');
    const [propertyCity, setPropertyCity] = useState('');
    const [propertyState, setPropertyState] = useState('');
    const [utcOffset, setUtcOffset] = useState('');
    const [status, setStatus] = useState('');
    const [errors, setErrors] = useState({
        ownership: '',
        region: '',
        propertyName: '',
        propertyDescription: '',
        propertyCity: '',
        propertyState: '',
        utcOffset: '',
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isValid = validateForm();
        if (isValid) {
            console.log('Form submitted!');
            let data = {
                ownershipgroups_id: ownership?.value || null,
                regions_id: region?.value || null,
                region_name: region?.label,
                property_name: propertyName,
                propertyDescription: propertyDescription,
                property_city: propertyCity,
                propertyState: propertyState,
                local_utc_offset: utcOffset,
                status_val: status?.value

            }
            await props.handleAction(data)
        }
    };

    const validateForm = () => {
        const newErrors = {
            ownership: '',
            region: '',
            propertyName: '',
            propertyDescription: '',
            propertyCity: '',
            propertyState: '',
            utcOffset: '',
        };

        let isValid = true;
        console.log(ownership)
        if (!ownership.value) {
            newErrors.ownership = 'Ownership is required';
            isValid = false;
        }

        if (!region.value) {
            newErrors.region = 'Region is required';
            isValid = false;
        }

        if (!propertyName.trim()) {
            newErrors.propertyName = 'Property Name is required';
            isValid = false;
        }

        if (!propertyDescription.trim()) {
            newErrors.propertyDescription = 'Property Description is required';
            isValid = false;
        }

        if (!propertyCity.trim()) {
            newErrors.propertyCity = 'Property City is required';
            isValid = false;
        }

        if (!propertyState.trim()) {
            newErrors.propertyState = 'Property State is required';
            isValid = false;
        }

        if (!utcOffset.trim()) {
            newErrors.utcOffset = 'UTC Offset is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    // fetch ownership records
    async function fetchOwnershipGroups() {
        try {
            const response = await nbrApi.post('/listownershipgroups')

            const data = response.data

            // Get the select element
            let modified_data = data?.map(e => {
                return {
                    ...e,
                    value: e?.pk_id,
                    label: e?.group_name
                }
            })

            setOwnershipOptions(modified_data)
        } catch (error) {
            console.error(error)
        }
    }

    // init
    useEffect(() => {
        fetchOwnershipGroups()
    }, [])

    useEffect(() => {
        if(props?.data){
            let ppData = props?.data
                let findOwnership = ownershipOptions?.filter(e => parseInt(e?.pk_id) === parseInt(ppData?.ownershipgroups_id))
                let region = regionOptions?.filter(e => parseInt(e?.value) === parseInt(ppData?.regions_id))
                let status = statusOptions?.filter(e => e?.value === ppData?.status_val)
                
                setOwnership(findOwnership?.[0])
                setRegion(region?.[0])
                setPropertyName(ppData?.property_name)
                setPropertyCity(ppData?.property_city)
                setPropertyDescription(ppData?.property_description)
                setPropertyState(ppData?.property_state)
                setUtcOffset(ppData?.local_utc_offset)
                setStatus(status?.[0])
        }
    },[props])

    return (
        <form onSubmit={handleSubmit}>
            <div className="mb-3">
                <label className="form-label">Ownership Group:</label>
                <Select options={ownershipOptions} onChange={(selectedOption) => setOwnership(selectedOption)} value={ownership} />
                {errors.ownership && <div className="text-danger m-2">{errors.ownership}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Regions:</label>
                <Select options={regionOptions} onChange={(selectedOption) => setRegion(selectedOption)} value={region} />
                {errors.region && <div className="text-danger m-2">{errors.region}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Property Name:</label>
                <input type="text" className="form-control" value={propertyName} onChange={(e) => setPropertyName(e.target.value)} />
                {errors.propertyName && <div className="text-danger m-2">{errors.propertyName}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Property Description:</label>
                <input type="text" className="form-control" value={propertyDescription} onChange={(e) => setPropertyDescription(e.target.value)} />
                {errors.propertyDescription && <div className="text-danger m-2">{errors.propertyDescription}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Property City:</label>
                <input type="text" className="form-control" value={propertyCity} onChange={(e) => setPropertyCity(e.target.value)} />
                {errors.propertyCity && <div className="text-danger m-2">{errors.propertyCity}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Property State:</label>
                <input type="text" className="form-control" value={propertyState} onChange={(e) => setPropertyState(e.target.value)} />
                {errors.propertyState && <div className="text-danger m-2">{errors.propertyState}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">UTC Offset:</label>
                <input type="text" className="form-control" value={utcOffset} onChange={(e) => setUtcOffset(e.target.value)} />
                {errors.utcOffset && <div className="text-danger m-2">{errors.utcOffset}</div>}
            </div>
            <div className="mb-3">
                <label className="form-label">Status:</label>
                <Select options={statusOptions} onChange={(selectedOption) => setStatus(selectedOption)} value={status} />
            </div>
            <button type="submit" className="btn btn-primary">Submit</button>
        </form>
    )
}

export default PropertyForm